"use strict";

require("core-js/modules/es.object.assign.js");
require("core-js/modules/es.symbol.description.js");
require("core-js/modules/es.weak-map.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.DefaultAddressFieldProps = exports.DefaultActionButtonsBarSetting = exports.AddressManualEntryPanel = exports.AddressManualEntryFields = void 0;
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/es.promise.js");
require("core-js/modules/es.array.reduce.js");
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Panel = require("../../../../../UIElements/Panels/Panel");
var _PageBanner = require("../../../../../UIElements/Banners/PageBanner");
var _InputText = require("../../../InputText");
var _Dropdown = require("../../../Dropdown/Dropdown");
var _ActionButtonsBar = require("../../../ActionButtonsBar/ActionButtonsBar");
var _SectionWrapper = require("../../../../../UIElements/SectionWrapper/SectionWrapper");
var _objectHelpers = require("../../../../../../helpers/objectHelpers");
var _panelPropTypes = require("../../../../../../propTypes/panelPropTypes");
var _propTypes2 = require("../../../../../../propTypes");
require("./addressManualEntryPanel.scss");
const _excluded = ["editButton"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
const DefaultAddressFieldProps = exports.DefaultAddressFieldProps = {
  streetAddress: {
    label: 'Street address',
    name: 'streetAddress',
    validation: {
      'required': 'This field is required.'
    }
  },
  suburb: {
    label: 'Suburb',
    name: 'suburb',
    validation: {
      'required': 'This field is required.'
    }
  },
  state: {
    label: 'State',
    name: 'state',
    validation: {
      'required': 'This field is required.'
    }
  },
  postcode: {
    label: 'Postcode',
    name: 'postcode',
    readOnly: true,
    editButton: {
      onEditPostCode: () => {},
      label: 'Change postcode',
      hideLabel: true,
      icon: 'pencil'
    }
  }
};
const DefaultActionButtonsBarSetting = exports.DefaultActionButtonsBarSetting = {
  actionsItems: [{
    buttonLabel: 'Continue',
    id: 'submitButton',
    buttonStyle: 'primary'
  }, {
    id: 'cancelButton',
    buttonStyle: 'secondary',
    buttonLabel: 'Close'
  }],
  containerType: 'row'
};
const AddressManualEntryFields = _ref => {
  let {
    formContext,
    formId,
    FIELD_IDS,
    streetAddress,
    suburb,
    state,
    postcode,
    showPanelError
  } = _ref;
  const {
      editButton
    } = postcode,
    rest = _objectWithoutProperties(postcode, _excluded);
  const handlePostCodeChange = postcodeValue => {
    // Trigger an update to the state and suburb dropdowns
    postcode.editButton.onEditPostCode(postcodeValue);
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "petSureForm"
  }, showPanelError && /*#__PURE__*/_react.default.createElement(_PageBanner.PageBanner, {
    id: "".concat(formId, "_manualAddressEntryError"),
    displayMode: "inline",
    type: "error",
    animation: "none",
    autoHide: false,
    showAcknowledgeCheck: false
  }, "Please fix all errors before continuing."), /*#__PURE__*/_react.default.createElement("fieldset", {
    className: "addressManualEntryPanel"
  }, /*#__PURE__*/_react.default.createElement(_InputText.InputText, _extends({
    fieldFormContext: formContext
  }, streetAddress, {
    name: FIELD_IDS.streetAddress,
    customCssClass: "streetAddressField"
  })), /*#__PURE__*/_react.default.createElement(_Dropdown.Dropdown, _extends({
    fieldFormContext: formContext
  }, suburb, {
    name: FIELD_IDS.suburb
  })), /*#__PURE__*/_react.default.createElement(_Dropdown.Dropdown, _extends({
    fieldFormContext: formContext
  }, state, {
    name: FIELD_IDS.state
  })), /*#__PURE__*/_react.default.createElement(_InputText.InputText, _extends({
    fieldFormContext: formContext
  }, rest, {
    name: FIELD_IDS.postcode,
    customChangeHandler: handlePostCodeChange
  }))));
};
exports.AddressManualEntryFields = AddressManualEntryFields;
AddressManualEntryFields.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  formContext: _propTypes.default.shape.isRequired,
  formId: _propTypes.default.string.isRequired,
  FIELD_IDS: _propTypes.default.shape.isRequired,
  streetAddress: _propTypes.default.shape(_propTypes2.FormFieldPropTypes),
  suburb: _propTypes.default.shape(_propTypes2.DropdownPropTypes),
  state: _propTypes.default.shape(_propTypes2.DropdownPropTypes),
  postcode: _propTypes.default.shape(_objectSpread(_objectSpread({}, _propTypes2.FormFieldPropTypes), {}, {
    editButton: _propTypes.default.shape(_objectSpread(_objectSpread({
      onEditPostCode: _propTypes.default.func
    }, _propTypes2.FieldLabelTextPropTypes), {}, {
      icon: _propTypes.default.string
    }))
  })),
  showPanelError: _propTypes.default.bool.isRequired
};
const AddressManualEntryPanel = _ref2 => {
  var _actionButtonsBarSett, _actionButtonsBarSett2;
  let {
    formContext,
    formId,
    onClose = () => {},
    onContinue = () => {},
    panelProps = {
      type: 'modal',
      fixed: true,
      size: 'small',
      open: true,
      scrollContent: true,
      modalLabel: 'Popup dialog for entering address',
      header: {
        fixed: true,
        content: 'Please enter your address'
      }
    },
    displayMode = 'modal',
    defaultFieldProps = DefaultAddressFieldProps,
    customFieldProps = DefaultAddressFieldProps,
    actionButtonsBarSetting = DefaultActionButtonsBarSetting
  } = _ref2;
  const [showPanelError, setShowPanelError] = (0, _react.useState)(false);
  const {
    streetAddress,
    suburb,
    state,
    postcode
  } = (0, _objectHelpers.DeepMergeObjects)({
    baseObject: defaultFieldProps,
    overrideObject: customFieldProps
  });
  const FIELD_IDS = {
    streetAddress: "".concat(formId, "_").concat(streetAddress.name),
    suburb: "".concat(formId, "_").concat(suburb.name),
    state: "".concat(formId, "_").concat(state.name),
    postcode: "".concat(formId, "_").concat(postcode.name)
  };
  const submitButton = actionButtonsBarSetting === null || actionButtonsBarSetting === void 0 || (_actionButtonsBarSett = actionButtonsBarSetting.actionItems) === null || _actionButtonsBarSett === void 0 ? void 0 : _actionButtonsBarSett.find(item => item.id === 'submitButton');
  const cancelButton = actionButtonsBarSetting === null || actionButtonsBarSetting === void 0 || (_actionButtonsBarSett2 = actionButtonsBarSetting.actionItems) === null || _actionButtonsBarSett2 === void 0 ? void 0 : _actionButtonsBarSett2.find(item => item.id === 'cancelButton');
  const AddressPiecesAreValid = async () => {
    let addressPiecesAreValid = true;
    await Object.values(FIELD_IDS).reduce(async (prevPromise, fieldId) => {
      formContext.setFocus(fieldId);
      await formContext.trigger(fieldId);
      if (formContext.getFieldState(fieldId).invalid) {
        addressPiecesAreValid = false;
        formContext.setFocus(fieldId);
        setShowPanelError(true);
      }
    }, Promise.resolve());
    setShowPanelError(false);
    return addressPiecesAreValid;
  };

  // Validate all pieces first.
  // If they are not valid show the error message and highlight the errors.
  // If they are valid return all the values with simplified keys.
  const HandlePanelContinue = () => {
    AddressPiecesAreValid().then(validState => {
      if (validState) {
        const addressValues = Object.entries(formContext.getValues()).reduce((acc, _ref3) => {
          let [key, value] = _ref3;
          const simpleFieldKey = Object.keys(FIELD_IDS).find(simpleKey => FIELD_IDS[simpleKey] === key);
          acc[simpleFieldKey] = value;
          return acc;
        }, {});
        onContinue(_objectSpread({}, addressValues));
      }
    });
  };

  // Return whatever values we have whether they are valid or not
  const HandlePanelClose = () => {
    const addressValues = Object.entries(formContext.getValues()).reduce((acc, _ref4) => {
      let [key, value] = _ref4;
      const simpleFieldKey = Object.keys(FIELD_IDS).find(simpleKey => FIELD_IDS[simpleKey] === key);
      acc[simpleFieldKey] = value;
      return acc;
    }, {});
    onClose(_objectSpread({}, addressValues));
  };
  const AddressManualEntryFooter = () => /*#__PURE__*/_react.default.createElement(_ActionButtonsBar.ActionButtonsBar, _extends({}, actionButtonsBarSetting, {
    actionItems: [_objectSpread(_objectSpread({}, submitButton), {}, {
      onClick: HandlePanelContinue
    }), _objectSpread(_objectSpread({}, cancelButton), {}, {
      onClick: HandlePanelClose
    })]
  }));
  if (displayMode === 'modal') {
    return /*#__PURE__*/_react.default.createElement(_Panel.Panel, _extends({}, panelProps, {
      onClose: HandlePanelClose,
      footer: {
        fixed: true,
        content: AddressManualEntryFooter()
      }
    }), /*#__PURE__*/_react.default.createElement(AddressManualEntryFields, {
      formContext: formContext,
      formId: formId,
      FIELD_IDS: FIELD_IDS,
      streetAddress: streetAddress,
      suburb: suburb,
      state: state,
      postcode: postcode,
      showPanelError: showPanelError
    }));
  }
  return /*#__PURE__*/_react.default.createElement(_SectionWrapper.SectionWrapper, {
    headerButtonCustomLabel: panelProps.header.content
  }, /*#__PURE__*/_react.default.createElement(AddressManualEntryFields, {
    formContext: formContext,
    formId: formId,
    FIELD_IDS: FIELD_IDS,
    streetAddress: streetAddress,
    suburb: suburb,
    state: state,
    postcode: postcode,
    showPanelError: showPanelError
  }), /*#__PURE__*/_react.default.createElement(AddressManualEntryFooter, null));
};
exports.AddressManualEntryPanel = AddressManualEntryPanel;
const addressManualEntryPanelFieldPropTypes = _propTypes.default.shape({
  streetAddress: _propTypes.default.shape(_propTypes2.FormFieldPropTypes),
  suburb: _propTypes.default.shape(_propTypes2.DropdownPropTypes),
  state: _propTypes.default.shape(_propTypes2.DropdownPropTypes),
  postcode: _propTypes.default.shape(_objectSpread(_objectSpread({}, _propTypes2.FormFieldPropTypes), {}, {
    editButton: _propTypes.default.shape(_objectSpread(_objectSpread({
      onEditPostCode: _propTypes.default.func
    }, _propTypes2.FieldLabelTextPropTypes), {}, {
      icon: _propTypes.default.string
    }))
  }))
});
AddressManualEntryPanel.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  formContext: _propTypes.default.any.isRequired,
  formId: _propTypes.default.string.isRequired,
  onClose: _propTypes.default.func,
  onContinue: _propTypes.default.func,
  displayMode: _propTypes.default.oneOf(['modal', 'inline', 'accordion']),
  panelProps: _propTypes.default.shape(_panelPropTypes.PanelPropTypes),
  defaultFieldProps: addressManualEntryPanelFieldPropTypes,
  customFieldProps: addressManualEntryPanelFieldPropTypes,
  actionButtonsBarSetting: _propTypes.default.shape(_ActionButtonsBar.ActionButtonsBar)
};
var _default = exports.default = {
  AddressManualEntryPanel
};